<div class="container-fluid border rounded border-light col-lg-12 bg-light">
    <div class="text-chat row flex-column">            
        <div style="height: 60vh; width: 40vw; overflow-y: auto; padding-top: .5em;" class="bg-white">
            <div *ngFor="let message of messages" [ngClass]="{'justify-content-end': message.senderId == localId}"  class="mx-1 d-flex justify-content-end">
                <div class="mb-1">
                    <p class="text-dark badge-pill badge-light ">{{message.message}}</p>
                </div>
            </div>
        </div>
        <div class="form-group mb-0 d-flex align-items-center">
            <input (keypress)="handleKeyPress($event)" [(ngModel)]="newMessage" class="form-control" type="text" name="newMessage">
            <button class="btn btn-info" (click)="sendNewMessage()">Enviar</button>
        </div>
    </div> 
</div>
